const config = {
  isMaintaining: false,
  phoneNo: "+91 9377075095",
  mail: "sales@nidhicorp.com",
  address:
    "104, Indralok Apt., Opt. Sub Jail, Hanuman Sheri, Ring Road, Surat - 395001",
};

export default config;
